var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    fill: "rgba(255, 255, 255, 1)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m256 512c45.368 0 88.134-17.781 120.42-50.067s50.067-75.052 50.067-120.42v-171.026c0-45.368-17.781-88.134-50.067-120.42s-75.052-50.067-120.42-50.067-88.134 17.781-120.419 50.067c-32.287 32.286-50.067 75.052-50.067 120.42v171.025c0 45.368 17.781 88.134 50.067 120.42 32.285 32.287 75.051 50.068 120.419 50.068zm0-293.242c-9.649 0-17.5-7.85-17.5-17.5v-53.001c0-9.649 7.85-17.5 17.5-17.5s17.5 7.85 17.5 17.5v53.001c0 9.65-7.85 17.5-17.5 17.5zm-138.487-48.271c0-70.951 53.635-129.6 122.487-137.558v68.497c-19.463 6.669-33.5 25.135-33.5 46.831v53.001c0 21.695 14.036 40.162 33.5 46.831v46.169c0 8.837 7.164 16 16 16s16-7.163 16-16v-46.169c19.464-6.669 33.5-25.135 33.5-46.831v-53.001c0-21.695-14.036-40.162-33.5-46.831v-68.496c68.852 7.958 122.487 66.607 122.487 137.558v171.025c0 76.362-62.125 138.487-138.487 138.487s-138.487-62.125-138.487-138.487z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMouse);
export default __webpack_public_path__ + "static/media/mouse.43889ec3157ac60791b1266f652d6a2e.svg";
export { ForwardRef as ReactComponent };